import ActionTypes from '../constants/ActionTypes';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  items: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_DASHBOARD:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false
      }

    case ActionTypes.RECEIVE_DASHBOARD:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        lastUpdated: action.receivedAt
      }

    default:
      return state
  }
}